import { HOST_URL } from "../constants";
import { getAccessToken } from "../jwt";
export default {
  project: {
    create: function (
      project,
      tmpId,
      successHandler,
      errorHandler,
      uploadProgressHandler
    ) {
      let fd = new FormData();
      fd.append("name", project.name);
      fd.append("owner", project.owner);
      fd.append("slug", project.slug);
      fd.append("url", project.url);
      fd.append("ref_speaker", project.ref_speaker);
      fd.append("src_speaker", project.src_speaker);
      fd.append("dataset", project.dataset);
      const xhr = new XMLHttpRequest();

      xhr.addEventListener("load", (e) => {
        if (xhr.status === 200) {
          successHandler(xhr.response, tmpId);
        } else {
          errorHandler(xhr.response, xhr.status, tmpId);
        }
      });
      xhr.addEventListener("error", (e) => {
        console.log("Error uploadDataset");
      });
      xhr.upload.addEventListener("progress", uploadProgressHandler);

      xhr.open("POST", `${HOST_URL}/recorder/api/projects`);
      xhr.setRequestHeader("Authorization", `Bearer ${getAccessToken()}`);
      xhr.send(fd);
    },
    list: async function () {
      return fetch(`${HOST_URL}/recorder/api/projects`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
    },
    delete: async function (projectId) {
      return fetch(`${HOST_URL}/recorder/api/projects/${projectId}`, {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
    },
  },

  recording: {
    list: async function (projectId) {
      const url = new URL(`${HOST_URL}/recorder/api/recordings`);
      url.search = new URLSearchParams({ project_id: projectId });
      return fetch(url, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
    },
    update: async function (recording, userFile = null) {
      let fd = new FormData();
      fd.append("user_status", recording.user_status);
      fd.append("text", recording.text);
      if (userFile) {
        fd.append("data", userFile);
      }
      return fetch(`${HOST_URL}/recorder/api/recordings/${recording.id}`, {
        method: "PUT",
        body: fd,
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
    },
    bulkUpdate: async function (projectId, file) {
      let fd = new FormData();
      fd.append("project_id", projectId);
      fd.append("data", file);
      return fetch(`${HOST_URL}/recorder/api/recordings`, {
        method: "PUT",
        body: fd,
        headers: { Authorization: `Bearer ${getAccessToken()}` },
      });
    },
    review: async function (recording_id, reviewer_status) {
      return fetch(
        `${HOST_URL}/recorder/api/recordings/${recording_id}/review`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`,
          },
          body: JSON.stringify({ recording_id, reviewer_status }),
        }
      );
    },
  },
  comment: {
    list: async function (projectId) {
      const url = new URL(`${HOST_URL}/recorder/api/comments`);
      url.search = new URLSearchParams({ project_id: projectId });
      return fetch(url, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
    },
    create: async function (recordingId, text) {
      return fetch(`${HOST_URL}/recorder/api/comments`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
        method: "POST",
        body: JSON.stringify({ recording_id: recordingId, text }),
      });
    },
  },
};
